<template>
  <b-container class=" v2_color_black">
    <b-row align-h="center" align-v="center">
      <b-col sm="12" class="my-3">
        <b-card no-body class="w-100 m-auto v2_box_teal">
          <b-card-header
            class="v2_font_size_24 v2_color_black v2_box_teal_header"
          >
            Edit Profile
          </b-card-header>
          <v-wait :for="loaderId">
            <template slot="waiting">
              <half-circle-spinner />
              <div class="spinner-message my-3 text-center">
                Loading profile data...
              </div>
            </template>
            <b-card-body class="py-4 px-6" v-if="profileData">
              <b-form @submit.prevent="handleSubmit">
                <recruiter-form
                  ref="recruiterForm"
                  :initial-data="user"
                />
                <b-form-row>
                  <b-col cols="6" class="text-right mt-3">
                    <b-button
                      variant="v2_main"
                      type="submit"
                      class="px-5"
                      :disabled="isSavingInProgress"
                      @click="handleButtonClick('Back')"
                    >
                      <b-spinner v-if="isSavingInProgress" small />
                      <span v-else>Back</span>
                    </b-button>
                  </b-col>
                   <b-col cols="6" class="d-flex justify-content-right mt-3">
                    <b-button
                      variant="v2_main"
                      type="submit"
                      class="px-5"
                      :disabled="isSavingInProgress"
                      @click="handleButtonClick('Next')"
                    >
                      <b-spinner v-if="isSavingInProgress" small />
                      <span v-else>Next</span>
                    </b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-card-body>
          </v-wait>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import RecruiterForm from '@/components/recruiter/form/RecruiterForm';
import { HalfCircleSpinner } from 'epic-spinners';
import { SET_USER_MUTATION } from '@/store';

export default {
  name: 'RecruiterEditProfile',
  components: {
    RecruiterForm,
    HalfCircleSpinner,
  },
  data: function () {
    return {
      profileData: null,
      isSavingInProgress: false,
    };
  },
  created: function () {
    this.getRecruiterProfile();
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
  methods: {
    handleSubmit: async function () {
      this.$refs.recruiterForm.validate();
      if (this.$refs.recruiterForm.hasErrors()) {
        return;
      }
      this.isSavingInProgress = true;
      try {
        const profileData = this.$refs.recruiterForm.getData();
        const { user, profile } = await Api.updateRecruiterProfile(profileData);
        this.$store.state.user.profile = profile;
        this.profileData = {
          ...user,
          ...profile,
        };
        
        this.$store.commit(SET_USER_MUTATION, {
          ...this.$store.state.user,
          ...user,
        });
        this.$toasted.success('Profile is updated', {
          duration: 3000,
        }); 
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isSavingInProgress = false;
      }
    },
    handleButtonClick(label) {
      // Perform actions based on the button's label
      if (label === 'Next') {
        this.$router.push("/recruiter/review-job-opportunity");
      } else if (label === 'Back') {
        // Do something for the "Back" button
        this.$router.push("/recruiter/ico");
      }
    },
    getRecruiterProfile: async function () {
      this.$wait.start(this.loaderId);
      try {
        this.profileData = await Api.getRecruiterProfile();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped></style>
